import { legacy_createStore as createStore, Store as ReduxStore } from 'redux'
import { Reducer } from './reducers';
import { States, Actions } from './type';

const Store: ReduxStore<States, Actions> = createStore(Reducer);
export default Store;